"use strict";
/* globals module */
/**
 * @module notificationsClient
 * @description  Notifications Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsClient` uses `notificationsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var _1 = require("./");
var NotificationsClient = /** @class */ (function () {
    function NotificationsClient(notificationsPublishClient, basicNotificationsSubscriptionsClient, notificationsRegistrationsClient, notificationsSettingsClient, notificationsRoute) {
        this.notificationsPublishClient = notificationsPublishClient;
        this.basicNotificationsSubscriptionsClient = basicNotificationsSubscriptionsClient;
        this.notificationsRegistrationsClient = notificationsRegistrationsClient;
        this.notificationsSettingsClient = notificationsSettingsClient;
        this.notificationsRoute = notificationsRoute;
    }
    Object.defineProperty(NotificationsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "publish", {
        get: function () {
            return this.notificationsPublishClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "subscriptions", {
        get: function () {
            return this.basicNotificationsSubscriptionsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "registrations", {
        get: function () {
            return this.notificationsRegistrationsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "settings", {
        get: function () {
            return this.notificationsSettingsClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    NotificationsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsPublishClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.NotificationsSettingsClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.NotificationsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsPublishClient !== "undefined" && _1.NotificationsPublishClient) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsClient !== "undefined" && _1.NotificationsSubscriptionsClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsClient !== "undefined" && _1.NotificationsRegistrationsClient) === "function" ? _c : Object, typeof (_d = typeof _1.NotificationsSettingsClient !== "undefined" && _1.NotificationsSettingsClient) === "function" ? _d : Object, typeof (_e = typeof _1.NotificationsRoute !== "undefined" && _1.NotificationsRoute) === "function" ? _e : Object])
    ], NotificationsClient);
    return NotificationsClient;
}());
exports.NotificationsClient = NotificationsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
